import { v4 as uuidv4 } from 'uuid'

export const structuralIssuesTestData = {
  title: 'Structural Issues',
  item: 'Prospect is a C-Corp',
  key: uuidv4()
}
